<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" class="text-center">
      <v-text-field v-model="email.subject"
                    color="kbDarkBlueText"
                    class="mt-4 text-center"
                    hide-details
                    style="max-width: 600px; margin: auto"
                    :label="$t('general.subject')"
                    ref="emailSubjectField"
                    outlined
                    single-line
                    clearable
                    :rules="[rules.required]"
                    v-on="{click: signalEmailSubjectHandler, keyup: signalEmailSubjectHandler}"/>
    </v-col>
    <v-col class="text-center mb-4" cols="12" >
      <btn-customize-field  :propModif="'subject'"
                            :itemToCustomize="$t('general.subject')"
                            :domElemCursorPosition="'emailSubjectCaretPosition'"
                            :accessDataObject="'email'"
                            @customizeMessage="customizeMessage"/>
    </v-col>
    <template v-if="$route.name === 'Disparadores'">
      <v-col cols="12" class="text-center">
        <p>{{ $t('general.insertHtmlTemplate') }}</p>
        <div style="border: 2px solid rgba(0,0,0,0.54); max-width: 600px; margin: auto; padding: 0">
        <pre v-highlightjs="email.html" style="height: fit-content; line-height: 0;">
          <code class="xml" contenteditable="true"
                style="display: block; min-height: 200px; resize: vertical; overflow-y: auto; text-align: left; line-height: 1.5; white-space: pre;"
                :rules="[rules.required]"
                v-on="{click: clickEmailHtmlHandler, keyup: keyupEmailHtmlHandler, blur: blurEmailHtmlHandler}"/>
        </pre>
        </div>
      </v-col>
      <v-col cols="12" style="max-width: 600px; margin: auto">
        <v-row>
          <v-col class="text-center mb-4" cols="6" >
            <btn-customize-field  :propModif="'html'"
                                  :itemToCustomize="$t('general.message')"
                                  :domElemCursorPosition="'emailHtmlCaretPosition'"
                                  :accessDataObject="'email'"
                                  @customizeMessage="customizeMessage"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn  color="kbPurple"
                    dark
                    v-on:click="prevHtmlTemplate">
              <v-icon left>remove_red_eye</v-icon>
              {{ $t('general.previewTemplate') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </template>

    <template v-else-if="$route.path.includes('sequences')">
    </template>
  </v-row>
</template>
<script>
import BtnCustomizeField from '@/pages/App/Communications/CustomizeFields/BtnCustomizeField.vue'
import customMessages from '@/libs/customMessages'
import rules from '@/libs/rules'
import Vue from 'vue'
import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS)
export default {
  components: { BtnCustomizeField },
  data () {
    return {
      emailSubjectCaretPosition: 0,
      emailHtmlCaretPosition: 0,
      rules
    }
  },
  methods: {
    setCursor (event, caretPos, elemModifCaretPos) {
      if (caretPos === undefined || caretPos === null) {
        // find parent element which is code tag for processing cursor pos
        var element = event.path.filter(function (el) {
          return el.nodeName === 'CODE'
        })[0]
        caretPos = this.getCaretPosition(element)
      }
      this[elemModifCaretPos] = caretPos
    },
    clickEmailHtmlHandler (event) {
      this.setCursor(event, null, 'emailHtmlCaretPosition')
    },
    keyupEmailHtmlHandler (event) {
      this.setCursor(event, null, 'emailHtmlCaretPosition')
    },
    signalEmailSubjectHandler (event) {
      const textarea = this.$refs.emailSubjectField.$refs.input
      const cursorPosition = textarea.selectionStart
      this.setCursor(event, cursorPosition, 'emailSubjectCaretPosition')
    },
    getCaretPosition (element) {
      // https://stackoverflow.com/a/4812022
      var caretOffset = 0
      var doc = element.ownerDocument || element.document
      var win = doc.defaultView || doc.parentWindow
      var sel
      if (typeof win.getSelection !== 'undefined') {
        sel = win.getSelection()
        if (sel.rangeCount > 0) {
          var range = win.getSelection().getRangeAt(0)
          var preCaretRange = range.cloneRange()
          preCaretRange.selectNodeContents(element)
          preCaretRange.setEnd(range.endContainer, range.endOffset)
          caretOffset = preCaretRange.toString().length
        }
      } else if ((sel = doc.selection) && sel.type !== 'Control') {
        var textRange = sel.createRange()
        var preCaretTextRange = doc.body.createTextRange()
        preCaretTextRange.moveToElementText(element)
        preCaretTextRange.setEndPoint('EndToEnd', textRange)
        caretOffset = preCaretTextRange.text.length
      }
      return caretOffset
    },
    blurEmailHtmlHandler (event) {
      this.setHtml(event)
    },
    setHtml (data) {
      this.email.html = data.srcElement.innerText
    },
    prevHtmlTemplate () {
      var newWindow = window.open()
      newWindow.document.title = 'Preview Message'
      newWindow.document.write(this.email.html)
      newWindow.stop()
    },
    customizeMessage (item, propModif, domElemCaretPostion, accessDataObject) {
      const src = this[accessDataObject][propModif]
      const caretPos = this[domElemCaretPostion]
      const value = ` ${item.value} `
      this[accessDataObject][propModif] = customMessages.customizeMessage(value, src, caretPos)
      this[domElemCaretPostion] = caretPos + value.length
    }
  },
  props: {
    email: {
      type: Object,
      required: true
    }
  }
}
</script>
